import { atom } from 'recoil';
import { WindowLevel } from '~/domain/patient/windowLevel';

export type Tools = 'pan' | 'window' | 'brush' | 'line';

export type Operations =
    | 'edit-slice'
    | 'interpolation'
    | 'grid-layout-resizing';

export const defaultWindowLevel = new WindowLevel(400, 20);

export const defaultMainViewWidth = 61.8; // the width is defined in % of the layout container width

export const minSliceInterval = 2; // Minimum value for keeping every nth slice

export const defaultWindowLevelState = atom<WindowLevel>({
    key: 'defaultWindowLevelState',
    default: defaultWindowLevel,
});

export const selectedToolState = atom<Tools>({
    key: 'selectedToolState',
    default: 'pan',
});

export const zoomToCursorState = atom<boolean>({
    key: 'zoomToCursorState',
    default: true,
});

export const selectedOperationState = atom<Operations | null>({
    key: 'selectedOperationState',
    default: null,
});

export const reviewToolState = atom<boolean>({
    key: 'reviewToolState',
    default: false,
});

export const windowLevelState = atom<WindowLevel>({
    key: 'windowLevelState',
    default: undefined,
});

export const mainViewWidthState = atom<number>({
    key: 'mainViewWidthState',
    default: defaultMainViewWidth,
});

export type BrushOptions = {
    diameter: number;
    mode: 'static' | 'smart';
    erase: boolean;
};

export const brushOptionsState = atom<BrushOptions>({
    key: 'brushOptionsState',
    default: {
        diameter: 20,
        mode: 'static',
        erase: false,
    },
});

export const brushDiameterLabelVisibleState = atom<boolean>({
    key: 'brushDiameterLabelVisibleState',
    default: false,
});

export const contourClearanceModeState = atom<'current' | 'all'>({
    key: 'contourClearanceModeState',
    default: 'current',
});

export type LineOptions = {
    width: number;
    color: string;
    mode: 'draw' | 'erase' | null;
};

export const lineOptionsState = atom<LineOptions>({
    key: 'lineOptionsState',
    default: {
        width: 2,
        color: '#050505',
        mode: null,
    },
});

export const keepEveryNthSliceState = atom<boolean>({
    key: 'keepEveryNthSliceState',
    default: false,
});

export const keepEveryNthSliceValueState = atom<number>({
    key: 'keepEveryNthSliceValueState',
    default: minSliceInterval,
});
